// CancelChequeModal.js
import React, { useState } from "react";

const CancelChequeModal = ({ show, onClose, onConfirm, isLoading }) => {
  const [chequeNumber, setChequeNumber] = useState("");

  const handleNumberClick = (number) => {
    setChequeNumber((prev) => prev + number);
  };

  const handleClear = () => {
    setChequeNumber("");
  };

  const handleBackspace = () => {
    setChequeNumber((prev) => prev.slice(0, -1));
  };

  const handleConfirm = () => {
    if (chequeNumber && !isLoading) {
      onConfirm(parseInt(chequeNumber, 10));
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '12px',
        width: '350px',
        maxWidth: '90%'
      }}>
        <h2 style={{ 
          marginTop: 0, 
          color: '#d32f2f',
          borderBottom: '2px solid #d32f2f',
          paddingBottom: '10px'
        }}>
          Cancelar Cheque
        </h2>
        
        <p style={{ marginBottom: '15px', color: '#555' }}>
          Ingresa el número de cheque que deseas cancelar:
        </p>
        
        <input
          type="text"
          value={chequeNumber}
          readOnly
          placeholder="Número de cheque"
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '20px',
            marginBottom: '20px',
            textAlign: 'center',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#f9f9f9'
          }}
        />
        
        <div className="numeric-keypad" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '10px',
          marginBottom: '20px'
        }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button
              key={num}
              onClick={() => handleNumberClick(num.toString())}
              style={{
                padding: '15px',
                fontSize: '18px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                backgroundColor: '#f0f0f0',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              {num}
            </button>
          ))}
          <button
            onClick={handleClear}
            style={{
              padding: '15px',
              fontSize: '18px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              backgroundColor: '#ff9800',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            C
          </button>
          <button
            onClick={() => handleNumberClick("0")}
            style={{
              padding: '15px',
              fontSize: '18px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              backgroundColor: '#f0f0f0',
              cursor: 'pointer'
            }}
          >
            0
          </button>
          <button
            onClick={handleBackspace}
            style={{
              padding: '15px',
              fontSize: '18px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              backgroundColor: '#f44336',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            ⌫
          </button>
        </div>
        
        <div className="modal-buttons" style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '10px'
        }}>
          <button
            onClick={() => {
              setChequeNumber("");
              onClose();
            }}
            disabled={isLoading}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.5 : 1
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={!chequeNumber || isLoading}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: '#d32f2f',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: (!chequeNumber || isLoading) ? 'not-allowed' : 'pointer',
              opacity: (!chequeNumber || isLoading) ? 0.5 : 1,
              fontWeight: 'bold'
            }}
          >
            {isLoading ? 'Cancelando...' : 'Confirmar Cancelación'}
          </button>
        </div>
        
        <p style={{
          marginTop: '15px',
          fontSize: '12px',
          color: '#999',
          textAlign: 'center'
        }}>
          Esta acción generará un cheque negativo con todos los productos y pagos invertidos.
          El cheque original quedará marcado como cancelado.
        </p>
      </div>
    </div>
  );
};

export default CancelChequeModal;